import { render, staticRenderFns } from "./xxzyzjsj.vue?vue&type=template&id=446d31c7&scoped=true&"
import script from "./xxzyzjsj.vue?vue&type=script&lang=js&"
export * from "./xxzyzjsj.vue?vue&type=script&lang=js&"
import style0 from "./xxzyzjsj.vue?vue&type=style&index=0&id=446d31c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d31c7",
  null
  
)

export default component.exports